module.exports = __webpack_public_path__ + "static/img/AR@3x.7c0b270f.png";